export default __webpack_public_path__ + "static/media/almabetter-logo-new.10c6f2cd.png";